
import React from 'react';
import { Grid, Box, Typography } from '@mui/material';
import { PieChart, Pie, Cell, Tooltip, Legend } from 'recharts';
import { ChartContainer } from '../Chart';
const AIToHumanHandoverRateGrid = ({ displayData, assistantId, downloadAIToHumanTransferCSV, loading, filter }) => {
  const handleDownload = () => {
    downloadAIToHumanTransferCSV({ filter, assistant: assistantId, organization: null });
  };

  const renderChart = () => {
    if (displayData?.aiToHumanTransfer?.transferred || displayData?.aiToHumanTransfer?.notTransferred) {
      return (
        <PieChart>
          <Pie
            data={[
              { name: "Transferred", value: displayData?.aiToHumanTransfer?.transferred },
              { name: "Not Transferred", value: displayData?.aiToHumanTransfer?.notTransferred }
            ]}
            innerRadius={50}
            outerRadius={80}
            fill="#AAA"
            dataKey="value"
          >
            {["#02042D", "#CCCCCC"].map((entry, index) => (
              <Cell key={`cell-${index}`} fill={["#02042D", "#CCCCCC"][index]} />
            ))}
          </Pie>
          <Tooltip />
          <Legend />
        </PieChart>
      );
    } else {
      return(
        <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', height: '100%' }}>
              <Typography variant="body1" sx={{ color: 'text.secondary', fontStyle: 'italic' }}>
              No data found for applied filters.
              </Typography>
          </Box>
      );
    }
  };

  return (
    <Grid item xs={12} md={6}>
      <ChartContainer
        title="AI to Human Handover Rate"
        subtitle="Rate of interactions transferred from AI to human agents for resolution."
        download={handleDownload}
        chart={renderChart()}
        loading={loading}
      />
    </Grid>
  );
};

export default AIToHumanHandoverRateGrid;
